import React from "react";
import { Skeleton } from "@mui/lab";
import { useHistory } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import {
  StyledRow,
  StyledTop,
  StyledName,
  StyledStatusPill,
  StyledBottom,
  StyledStatistic,
  StyledId,
  StyledMore
} from "../styles";

const OrganizationsItem = ({ id, name, statsMap }) => {
  const history = useHistory();

  const handleOrganizationClick = (id) => {
    history.push(`organizations/${id}/users`);
  };

  return (
    <StyledRow key={id} onClick={() => handleOrganizationClick(id)}>
      <div>
        <StyledTop>
          <StyledName>{name}</StyledName>
          <StyledStatusPill>Active</StyledStatusPill>
        </StyledTop>
        <StyledBottom>
          <StyledStatistic>
            {!statsMap.has(id) ? (
              <Skeleton variant="text" width={40} height={15} />
            ) : (
              <>
                <StyledId>{id}</StyledId> <GroupIcon />
                {statsMap.get(id)?.users.length}
              </>
            )}
          </StyledStatistic>
          <StyledStatistic>
            {!statsMap.has(id) ? (
              <Skeleton variant="text" width={40} height={15} />
            ) : (
              <>
                <VpnKeyIcon /> {statsMap.get(id)?.tokens.length}
              </>
            )}
          </StyledStatistic>
        </StyledBottom>
      </div>

      <StyledMore>
        <KeyboardArrowRightIcon />
      </StyledMore>
    </StyledRow>
  );
};

export { OrganizationsItem };

export default OrganizationsItem;
